export default __webpack_public_path__ + "media/images/onglet-gauchesmall3-12c03ca696e454e221037b1026c3f35c.png";